export default __webpack_public_path__ + "static/media/registration.ba11775c.jpg";